'use client'

import { useQuery } from '@tanstack/react-query'
import { useDynamicLanguage } from '@/app/[locale]/_hooks/useShipper'
import getPopups from '@/app/[locale]/_service/popups.service'
import dynamic from 'next/dynamic'

const PopupDisplayer = dynamic(
  () => import('@/app/[locale]/_components/PopupDisplayer'),
  {
    ssr: false,
  }
)
const ReviewOrder = dynamic(
  () => import('@/app/[locale]/_components/ReviewOrder'),
  {
    ssr: false,
  }
)

interface PopupsLayerProps {
  shipper_id: string | null
  platform_id: string
}

const DEFAULT_PAGINATION = { page: 1, limit: 10 }

export default function PopupsLayer({
  shipper_id,
  platform_id,
}: PopupsLayerProps) {
  const { useDynamicLanguage: dynamicLanguageEnabled, isShipperResolved } =
    useDynamicLanguage()

  const { data: popupsData } = useQuery({
    queryKey: ['home-popups', shipper_id, platform_id, dynamicLanguageEnabled],
    queryFn: async () => {
      if (!shipper_id) return null
      const response = await getPopups(
        DEFAULT_PAGINATION,
        shipper_id,
        platform_id,
        dynamicLanguageEnabled
      )
      return response?.data
    },
    enabled: !!shipper_id && isShipperResolved,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
    retry: 2,
  })

  const popups = popupsData?.popups

  if (!popups) return null

  return (
    <>
      <PopupDisplayer popups={popups} />
      <ReviewOrder popups={popups} />
    </>
  )
}
